import { ContextMenuState } from "./ContextMenuState";

import { ContextMenuItemStateCommand } from "./ContextMenuItemStateCommand";

import { ContextMenuItemStateCommandCriteria } from "./ContextMenuItemStateCommandCriteria";

import { ContextMenuItemState } from "./ContextMenuItemState";

import { enumerable } from "../../typescript/enumerable.decorator";

export class ContextMenuItem<T> {
  // compiler hints, please don't remove
  private menuState: ContextMenuState;
  private item: T;

  /* more complex subclassee's should also subclass ContextMenuItemState as required*/
  public state: ContextMenuItemState = new ContextMenuItemState();

  @enumerable(false)
  public checkAvailable: ContextMenuItemStateCommand<T>;
  @enumerable(false)
  public checkEnabled: ContextMenuItemStateCommand<T>;

  constructor(
    private _title = "",
    checkAvailable: ContextMenuItemStateCommand<T>,
    checkEnabled: ContextMenuItemStateCommand<T>,
    public checkAvailableCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.MenuItem,
    public checkEnabledCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.Item,
  ) {
    this.state.title = _title;

    Object.defineProperties(this, {
      checkAvailable: {
        value: checkAvailable,
        enumerable: false,
        writable: true,
      },
      checkEnabled: {
        value: checkEnabled,
        enumerable: false,
        writable: false,
      },
    });
  }

  public get title(): string {
    return this.state.title;
  }

  public set title(title: string) {
    this.state.title = title;
  }

  public get isAvailable(): boolean {
    return this.state.available;
  }

  public get isEnabled(): boolean {
    return this.state.enabled;
  }

  /* a more complex subclassee must implement this*/
  public reset(): void {
    let oldState = this.state;
    this.state = new ContextMenuItemState();
    this.state.title = oldState.title;
  }
}
